import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import Icon from '../../../core/Icon';

var MultiSelectOption =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MultiSelectOption, _React$Component);

  function MultiSelectOption() {
    _classCallCheck(this, MultiSelectOption);

    return _possibleConstructorReturn(this, _getPrototypeOf(MultiSelectOption).apply(this, arguments));
  }

  _createClass(MultiSelectOption, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$selectPro = _this$props.selectProps,
          classes = _this$props$selectPro.classes,
          renderOptionIcon = _this$props$selectPro.renderOptionIcon,
          children = _this$props.children,
          isFocused = _this$props.isFocused,
          isSelected = _this$props.isSelected,
          innerProps = _this$props.innerProps,
          innerRef = _this$props.innerRef,
          onFocus = _this$props.onFocus;
      var icon = null;

      if (typeof renderOptionIcon !== 'undefined') {
        icon = renderOptionIcon(this.props.data) || null;
      } else {
        icon = React.createElement(Icon, {
          type: this.props.data.icon,
          className: classes.optionIcon
        });
      }

      return React.createElement(MenuItem, Object.assign({
        buttonRef: innerRef,
        onFocus: onFocus,
        selected: isSelected,
        classes: {
          root: isFocused ? classes.optionMenuItemRootFocused : ''
        }
      }, innerProps, {
        innerRef: null,
        component: "div"
      }), React.createElement(Typography, {
        color: "inherit"
      }, icon, children));
    }
  }]);

  return MultiSelectOption;
}(React.Component);

export default MultiSelectOption;